export const actionTypes = {
  startLoading: "START_LOADING",
  loadSuccess: "LOAD_SUCCESS",
  loadError: "LOAD_ERROR",
  filterAction: "FILTER",
};
